import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FeatureCollection, Polygon, MultiPolygon } from '@turf/helpers';
import { PolygonSelectorService } from '../../Services/polygon-selector.service';
import { PolygonSelectionEvent } from '../../models/polygon-selector.models';
import { CloropetClases, CloropetConfiguration } from 'src/models/CloropetClases';

@Component({
  selector: 'simple-polygon-selector',
  templateUrl: './polygon-selector.component.html',
  styleUrls: ['./polygon-selector.component.css'],
  providers: [PolygonSelectorService]
})
export class PolygonSelectorComponent implements OnInit, OnDestroy {

  @Input() sourceName: string = '';
  @Input() geoJson: FeatureCollection<Polygon | MultiPolygon> = null;
  @Input() autoActivate: boolean = true;
  @Input() fillType: string = ""
  @Input() textProperty: string = "Description";
  @Input() hasMultipleSelection: boolean = false;

  @Input() cloropetConfig: CloropetConfiguration = null;
  @Input() useExternalLayers: boolean = false;

  @Output() selectionChange = new EventEmitter<PolygonSelectionEvent>();

  constructor(private polygonSelectorService: PolygonSelectorService) {}

  async ngOnInit(): Promise<void> {
    this.polygonSelectorService.configure(this.sourceName);

    this.polygonSelectorService.onSelectionChange((event) => {
      this.selectionChange.emit(event);
    });
    
    if (this.autoActivate) {
      // await this.polygonSelectorService.initialize(this.fillType);
  
      // if (this.geoJson) {
      //   this.polygonSelectorService.loadGeoJson(this.geoJson);
      // }
      await this.activate();
    }
  }

  ngOnDestroy(): void {
    this.polygonSelectorService.destroy();
  }

  loadGeoJson(geoJson: FeatureCollection<Polygon | MultiPolygon>): void {
    this.polygonSelectorService.loadGeoJson(geoJson);
  }

  clearGeoJson(): void {
    this.polygonSelectorService.clearGeoJson();
  }

  async activate(canSelect: boolean = true): Promise<void> {
    this.polygonSelectorService.cloropetConfig = this.cloropetConfig;
    this.polygonSelectorService.textProperty = this.textProperty;
    this.polygonSelectorService.multipleSelection = this.hasMultipleSelection;
    await this.polygonSelectorService.initialize(this.fillType, this.useExternalLayers, canSelect);

    if (this.geoJson) {
      this.polygonSelectorService.loadGeoJson(this.geoJson);
    }
    if (canSelect) {
      this.polygonSelectorService.activate();
    }
  }

  deactivate(): void {
    this.polygonSelectorService.deactivate();
  }

  selectAll(): void {
    this.polygonSelectorService.selectAll();
  }

  deselectAll(): void {
    this.polygonSelectorService.deselectAll();
  }

  selectByProperty(key: string, value: string): void {
    this.polygonSelectorService.selectByProperty(key, value);
  }

  selectById(id: string | number): void {
    this.polygonSelectorService.selectById(id);
  }

  clearSelection(): void {
    this.polygonSelectorService.clearSelection();
  }

  getSelectedFeatures(): FeatureCollection<Polygon | MultiPolygon> {
    return this.polygonSelectorService.getSelectedFeatures();
  }

  showLayers(): void {
    this.polygonSelectorService.showLayers();
  }

  hideLayers(): void {
    this.polygonSelectorService.hideLayers();
  }

  sendToTop(): void {
    this.polygonSelectorService.sendToTop();
  }
}
